module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_agder_pos.6f2949d1.pdf";